import React from 'react';
import { motion } from 'framer-motion';
import { Star, Trophy, ThumbsUp } from 'lucide-react';
interface StatusBadgeProps {
  isCorrect: boolean;
  motivationalText: string;
  xpGained: number;
  mode?: 'full' | 'compact';
}
/**
 * Displays the success/failure status with motivational message.
 * Compact and calm — celebrates without overwhelming.
 */
export function StatusBadge({
  isCorrect,
  motivationalText,
  xpGained,
  mode = 'full'
}: StatusBadgeProps) {
  if (mode === 'compact') {
    return <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${isCorrect ? 'bg-emerald-600 text-white' : 'bg-slate-200 text-slate-600'}`} data-id="element-1269">
        {isCorrect ? '✓' : '✗'}
      </div>;
  }
  return <motion.div initial={{
    scale: 0.95,
    opacity: 0,
    y: 12
  }} animate={{
    scale: 1,
    opacity: 1,
    y: 0
  }} transition={{
    type: 'spring',
    stiffness: 300,
    damping: 22
  }} className={`
        relative overflow-hidden rounded-2xl p-6 mb-4 text-center shadow-lg
        ${isCorrect ? 'bg-gradient-to-br from-emerald-500 to-emerald-600 text-white shadow-emerald-200/50' : 'bg-white border border-slate-200 text-slate-900 shadow-slate-100'}
      `} data-id="element-1270">
      {isCorrect ? <div className="flex flex-col items-center gap-2" data-id="element-1271">
          <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        delay: 0.15,
        type: 'spring',
        stiffness: 400
      }} className="bg-white/20 p-2.5 rounded-full backdrop-blur-sm" data-id="element-1272">
            <Trophy className="w-8 h-8 text-yellow-300 fill-yellow-300" data-id="element-1273" />
          </motion.div>

          <h2 className="text-2xl md:text-3xl font-black tracking-tight" data-id="element-1274">
            {motivationalText}
          </h2>

          <motion.div initial={{
        y: 8,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        delay: 0.25
      }} className="inline-flex items-center gap-1.5 bg-white/20 px-4 py-1.5 rounded-full backdrop-blur-md border border-white/20 text-base" data-id="element-1275">
            <span className="font-bold" data-id="element-1276">+{xpGained} XP</span>
            <Star className="w-4 h-4 fill-yellow-300 text-yellow-300" data-id="element-1277" />
          </motion.div>
        </div> : <div className="flex flex-col items-center gap-2" data-id="element-1278">
          <div className="bg-slate-100 p-2.5 rounded-full" data-id="element-1279">
            <ThumbsUp className="w-7 h-7 text-slate-400" data-id="element-1280" />
          </div>

          <h2 className="text-xl md:text-2xl font-black text-slate-800 tracking-tight" data-id="element-1281">
            {motivationalText}
          </h2>

          <p className="text-slate-500 font-medium text-base" data-id="element-1282">
            Geen zorgen, hier leer je van!
          </p>

          <div className="inline-flex items-center gap-1.5 bg-slate-50 px-3 py-1 rounded-full text-slate-500 border border-slate-100 text-sm" data-id="element-1283">
            <span className="font-bold" data-id="element-1284">+{xpGained} XP</span>
            <span className="text-xs uppercase tracking-wider font-semibold" data-id="element-1285">
              voor de inzet
            </span>
          </div>
        </div>}
    </motion.div>;
}